import React from 'react';
import styles from './Section.module.css';

export interface SectionProps {
  children: React.ReactNode;
  id?: string;
  className?: string;
  background?: 'primary' | 'secondary' | 'tertiary';
  paddingY?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * Section Component
 * Provides consistent vertical spacing
 */
export function Section({
  children,
  id,
  className = '',
  background = 'primary',
  paddingY = 'lg',
}: SectionProps) {
  const classNames = [
    styles.section,
    styles[`bg-${background}`],
    styles[`py-${paddingY}`],
    className,
  ].filter(Boolean).join(' ');

  return (
    <section id={id} className={classNames}>
      {children}
    </section>
  );
}
